export enum STAND_WORKSHEET_PERMISSION_CODE {
  BeginningCount = 'BeginCount',
  Adjustment = 'Adjustment',
  ExpectedQty = 'ExpectedQTY',
}
